import React from 'react';
import type { FC } from 'react';
import { SiteAuthProvider } from '@wix/cli-auth';
import type { DeploymentTopologyEnvironmentType } from '@wix/cli-astro-definitions';
import { useProjectModel } from '../../model.js';
import { Preview } from './Preview.js';

export const PreviewCommand: FC<{
  environment: DeploymentTopologyEnvironmentType;
  baseUrl?: string;
  label?: string;
  onPreviewCreated?: (args: { armTag: string; serverUrl: string }) => void;
}> = ({ environment, baseUrl, label, onPreviewCreated }) => {
  const {
    model: {
      config: { siteId },
    },
  } = useProjectModel();

  return (
    <SiteAuthProvider siteId={siteId}>
      <Preview
        baseUrl={baseUrl}
        onPreviewCreated={onPreviewCreated}
        environment={environment}
        label={label}
      />
    </SiteAuthProvider>
  );
};
